// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__EA1zc","modalSection":"Modal_modalSection__hQyaa","modalButtons":"Modal_modalButtons__S2eNF"};